export function getURLInfo() {
  const url = window.location.href;
  const parser = document.createElement('a');
  parser.href = url;

  const info = {
    host: parser.host, // include port
    hostname: parser.hostname, // exclude port
    port: parser.port || '',
    pathname: parser.pathname, // include /
    search: parser.search, // include ?
    params: {},
  };

  if (info.search) {
    const queryParams = info.search.substring(1).split('&');
    queryParams.forEach(function (param) {
      const pair = param.split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1] || '');
      // info.params[key] = value;
      info.params[key] = encodeURIComponent(value);
    });
  }

  return info;
}
